/*
  src/redux/loyalty/constants.js

  Created by Justin Chang on 5/16/2017.
*/
import { createConstant } from '../helpers';
const createConstantVariable = createConstant('loyalty');

// Set Constants
export const SET_CARD_NUMBER     = createConstantVariable('SET_CARD_NUMBER');
export const SET_CARD_AMOUNT     = createConstantVariable('SET_CARD_AMOUNT');
export const SET_BUFFER_AMOUNT   = createConstantVariable('SET_BUFFER_AMOUNT');
export const SET_GOAL_AMOUNT     = createConstantVariable('SET_GOAL_AMOUNT');
export const SET_LIFETIME_AMOUNT = createConstantVariable('SET_LIFETIME_AMOUNT');
export const SET_CARD_HAS_COUPON = createConstantVariable('SET_CARD_HAS_COUPON');
export const SET_ALL_CARD_DATA   = createConstantVariable('SET_ALL_CARD_DATA');
export const SET_COUPON_EXPIRATION_DATE = createConstantVariable('SET_COUPON_EXPIRATION_DATE');

// Failure Constants
export const FAIL_TO_LOAD_LOYALTY_CARD  = createConstantVariable('FAIL_TO_LOAD_LOYALTY_CARD');
export const FAIL_TO_LOAD_ALL_CARD_DATA = createConstantVariable('FAIL_TO_LOAD_ALL_CARD_DATA');
export const FAIL_TO_SET_LOYALTY_CARD   = createConstantVariable('FAIL_TO_SET_LOYALTY_CARD');
export const FAIL_TO_LOAD_LOYALTY_CARD_FROM_COOKIES  = createConstantVariable('FAIL_TO_LOAD_LOYALTY_CARD_FROM_COOKIES');
export const FAIL_TO_SET_GOAL_AMOUNT_FROM_COOKIES = createConstantVariable('FAIL_TO_SET_GOAL_AMOUNT_FROM_COOKIES');



// WEBPACK FOOTER //
// ./src/redux/loyalty/constants.js